import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import Loader from "../Loader/Loader";
import { useNavigate } from "react-router-dom";
import AirdropTransactionsLayer from "./AirdropTransactionsLayer";
import DateSettingModal from "../model/DateSettingModal";
import useApi from "../../hook/useApi";

const AirdropDashboardLayer = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const [showModal, setShowModal] = useState(false);
  const [settings, setSettings] = useState(null);

  const { AsyncGetApiCall } = useApi();

  const fetchAirdropSetting = async () => {
    const res = await AsyncGetApiCall("/airdrop/get-setting");

    if (res?.success) {
      setSettings(res.data);
    }
  };

  useEffect(() => {
    fetchAirdropSetting();
  }, []);

  const handleModalClose = (shouldRefetch = false) => {
    setShowModal(false);
    if (shouldRefetch) {
      fetchAirdropSetting();
    }
  };

  return (
    <div className="card h-100 p-0 radius-12">
      {loading && <Loader />}
      <div className="card-header border-bottom bg-base py-16 px-24 d-flex align-items-center flex-wrap gap-3 justify-content-between">
        <h6 className="fw-medium">Airdrop Transactions</h6>
        <button
          onClick={() => setShowModal(true)}
          className="btn btn-primary d-flex align-items-center gap-2 ms-auto"
        >
          <Icon icon="mdi:plus" className="text-lg" />
          Update Date
        </button>
        <div
          className="d-flex align-items-center gap-10 btn btn-primary"
          onClick={() => {
            navigate("/campaign-manage/bulk-upload");
          }}
        >
          <button type="button">Bulk Upload</button>
          <Icon icon="ic:baseline-upload" className="icon text-xl" />
        </div>
      </div>
      <AirdropTransactionsLayer />

      <DateSettingModal
        show={showModal}
        handleClose={handleModalClose}
        mode="create"
        data={settings}
      />
    </div>
  );
};

export default AirdropDashboardLayer;
